import { useMemo, memo } from "react";
import Chart from "react-apexcharts";
import './chart.css';

function Pyramid({
  data,
  categoryKey,
  valueKey,
  percentageKey,
  chartType = "bar",
  titleX,
  titleY,
  isHorizontal = true,
  seriesName = "Data",
  showPercentage = false,
}) {
  const incidenciaData = useMemo(() => {
    const male = { name: 'Masculino', data: [] };
    const female = { name: 'Feminino', data: [] };
    Object.entries(data.Incidencias).forEach(([, incidencia]) => {
      male.data.push(incidencia.M.Incidencia.toFixed(1));
      female.data.push((incidencia.F.Incidencia.toFixed(1)) * -1);
    });
    male.data.reverse();
    female.data.reverse();
    return [male, female];
  }, [data]);

  const options = useMemo(
    () => ({
      chart: { type: 'bar', height: 440, stacked: true },
      colors: ['#008FFB', '#FF4560'],
      plotOptions: {
        bar: {
          borderRadius: 5,
          borderRadiusApplication: 'end',
          borderRadiusWhenStacked: 'all',
          horizontal: true,
          barHeight: '75%',
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => showPercentage ? `${Math.abs(val.toFixed(1))}%` : Math.abs(val),
      },
      stroke: { width: 1, colors: ["#fff"] },
      grid: { xaxis: { lines: { show: false } } },
      yaxis: { stepSize: 5 },
      title: {
        text: [`Idade media: ${Math.round(data.Valores.Media)}`, `Idade mediana: ${Math.round(data.Valores.Mediana)}`],
        align: 'middle',
      },
      tooltip: {
        shared: false,
        x: { formatter: (val) => val },
        y: { formatter: (val) => Math.abs(val) + "%" },
      },
      xaxis: {
        categories: ['60 ou mais', '40-59', '15-39', '5-14', '0-4'],
        labels: { formatter: () => null },
      },
    }),
    [data.Valores, showPercentage]
  );

  return (
    <Chart options={options} series={incidenciaData} type={chartType} height="100%" width="100%" />
  );
}

export default memo(Pyramid);
